<template lang="pug">
.the-show-header
  v-tooltip(bottom)
    template(v-slot:activator="{ on, attrs }")
      v-btn(icon, v-bind="attrs", v-on="on", @click="open")
        v-icon mdi-filter
    span Date Filter
  v-dialog(v-model="dialog", max-width="700px", persistent, :fullscreen="isMobile")
    v-card
      validation-observer(ref="observer", v-slot="{ validate, invalid}")
        v-card-title Date Filter
        v-divider
        v-card-text
          v-row(no-gutters)
            v-col(cols="12")
              validation-provider(v-slot="{ errors }", name="date filter", rules="required")
                v-select(
                  v-model="selected",
                  :error-messages="errors",
                  :items="items",
                  item-text="name",
                  item-value="id",
                  placeholder="Select Date Filter",
                  label="Date Filter")
            v-col(cols="12", v-if="selected == TYPE_DATEFILTER_STATUS.CUSTOM_DATE.ID")
              v-menu(
                ref="menu_from",
                v-model="holder.date_from.menu",
                :close-on-content-click="false",
                :return-value.sync="holder.date_from.value",
                transition="scale-transition",
                offset-y,
                min-width="290px")
                template(v-slot:activator="{ on, attrs }")
                  validation-provider(v-slot="{ errors }", name="date from", rules="required")
                    v-text-field(
                      :value="GetFormattedDateOnlyString(holder.date_from.value)",
                      label="Date From",
                      :error-messages="errors",
                      prepend-inner-icon="mdi-calendar",
                      readonly,
                      v-bind="attrs",
                      v-on="on")
                v-date-picker(v-model="holder.date_from.value", no-title, scrollable, :max="holder.date_to.value")
                  v-spacer
                  v-btn(text, color="primary", @click="holder.date_from.menu = false") Cancel
                  v-btn(text, color="primary", @click="$refs.menu_from.save(holder.date_from.value)") OK
              v-menu(
                ref="menu_to",
                v-model="holder.date_to.menu",
                :close-on-content-click="false",
                :return-value.sync="holder.date_to.value",
                transition="scale-transition",
                offset-y,
                min-width="290px")
                template(v-slot:activator="{ on, attrs }")
                  validation-provider(v-slot="{ errors }", name="date to", rules="required")
                    v-text-field(
                      :value="GetFormattedDateOnlyString(holder.date_to.value)",
                      label="Date From",
                      :error-messages="errors",
                      prepend-inner-icon="mdi-calendar",
                      readonly,
                      v-bind="attrs",
                      v-on="on")
                v-date-picker(v-model="holder.date_to.value", no-title, scrollable, :min="holder.date_from.value")
                  v-spacer
                  v-btn(text, color="primary", @click="holder.date_to.menu = false") Cancel
                  v-btn(text, color="primary", @click="$refs.menu_to.save(holder.date_to.value)") OK
        v-card-actions
          v-spacer
          v-btn(color="blue darken-1", text="", @click="close")
            | Close
          v-btn(color="blue darken-1", text="", :disabled="invalid", @click="validate().then(submit)")
            | Save
</template>
<script>
import { TYPE_DATEFILTER_STATUS, GetFormattedDateOnlyString, GetDateRange } from "@/helpers/Date";
import ValidateMixins from "@/mixins/ValidateMixins.vue";
export default {
  name: "TheDateFilterBy",
  mixins: [ValidateMixins],
  props: {
    filterBy: {
      type: Number,
      default: TYPE_DATEFILTER_STATUS.TODAY.ID
    }
  },
  data() {
    return {
      dialog: false,
      selected: null,
      holder: {
        date_from: {
          value: null,
          menu: false
        },
        date_to: {
          value: null,
          menu: false
        }
      },
      items: [],
      TYPE_DATEFILTER_STATUS
    };
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    GetFormattedDateOnlyString,
    initialize() {
      this.getType();
    },

    getType() {
      for (const key in TYPE_DATEFILTER_STATUS) {
        const element = TYPE_DATEFILTER_STATUS[key];
        if (element && element.SHOW_IN_MENU) {
          this.items.push({
            id: element.ID,
            name: element.TEXT
          });
        }
      }
    },
    open() {
      this.selected = this.filterBy;
      this.dialog = true;
      this.$nextTick(() => {
        // reset validation first
        this.$refs.observer.reset();
      });
    },
    close() {
      this.dialog = false;
    },
    submit(isValid) {
      if (!isValid) return;
      this.save();
    },
    save() {
      let date = GetDateRange(this.selected, {
        from: this.holder.date_from.value,
        to: this.holder.date_to.value
      });

      this.$emit("update", {
        selected: this.selected,
        date_from: date.from,
        date_to: date.to
      });
      this.close();
    }
  }
};
</script>
